import { get as _get } from 'lodash'
import store from '@/store'
import {TENDER_TYPES_MAP} from './consts'
import { tenderStatus, queryStatus } from '@/utils/locale'

export function showQueryIndicator (tender = {}) {
  const curUser = store && store.getters['user/currentUser']
  const isPic = deep(tender, 'general.managedBy') === curUser.id
  const isRep = tender.isRepresentative
  if (deep(tender, 'general.status') !== tenderStatus.REVIEW || !(isPic || isRep)) return false
  const bids = tender.bids && tender.bids.filter(bid => bid.queries && bid.queries.length)
  return bids.some(bid => bid.queries.some(query => query.status !== queryStatus.DRAFT))
}

export function getPurchases (object) {
  return _get(object, TENDER_TYPES_MAP[object.numberType], [])
}
